(ns frontend.view.reports.custom.view-3
  (:require
   [frontend.view.reports.custom.diamond-edge-ventures-deals :as diamond-edge-ventures-deals]
   [frontend.tenant-customizations :as tenant-customizations]))

(defn custom-view
  [args]
  [:div.py-3
   (when (tenant-customizations/diamond-edge-ventures?)
     [diamond-edge-ventures-deals/view args])])
